<ng-container *ngIf="vm$ | async as vm">
  <form name="frmNotitieReager" (ngSubmit)="saveSubj.next(vm)">

    <div class="header-row">
      <h1 class="head2">{{vm.notitie.Eigenaar}}</h1>
      <div class="headerright-row">
        <span class="head3">{{vm.notitie.DatumUpdate | date}}</span>
        <i tabindex="0" role="button" aria-label="Annuleer reactie op notitie" title="Annuleer reactie" class="icon-disagree c2-clickable" (keydown.enter)="cancel()" (click)="cancel()"></i>
      </div>
    </div>

    <div *ngIf="!vm.isEdit">
      <pre class="wrap">{{vm.notitie.Inhoud}}</pre>
    </div>

    <textarea *ngIf="vm.isEdit" [(ngModel)]="vm.reactie" name="reactie"></textarea>

    <h2 class="head3">{{vm.isEdit ? 'Wijzig':'Reageer'}}</h2>

    <textarea *ngIf="!vm.isEdit" name="reactie" [(ngModel)]="vm.reactie" rows="4"></textarea>

    <h3 class="head3">Ontvangers</h3>

    <div class="ontvangerspanel-row">

      <div class="allen-row customcheckbox">
        <input id="notitie-allen" title="Schakelen alle personen" name="allen" type="checkbox" [ngModel]="vm.allenSelected" (ngModelChange)="toggleAllenSubj.next($event)" />
        <label for="notitie-allen" aria-labelledby="notitie-allen" >Allen</label>
      </div>

      <div class="partijen-row">
        <div class="partij-col" *ngFor="let partij of vm.partijen trackBy:getPartijId">
          
          <div class="partij-naam-row customcheckbox">
            <input id="partij{{partij.Id}}" name="partij{{partij.Id}}" title="Schakelen {{partij.Naam}}" type="checkbox" [ngModel]="partij.isSelected" (ngModelChange)="togglePartijSubj.next(partij)" />
            <label for="partij{{partij.Id}}" [attr.aria-labelledby]="'partij'+partij.Id" >{{partij.Naam}}</label>
          </div>

          <div class="partij-persoon-row customcheckbox" *ngFor="let persoon of partij.Leden trackBy:getLidId">
            <input id="persoon{{persoon.Id}}" name="persoon{{persoon.Id}}" title="Schakelen {{persoon.Naam}}" type="checkbox" [ngModel]="persoon.isSelected" (ngModelChange)="togglePersoonSubj.next(persoon)" />
            <label for="persoon{{persoon.Id}}" [attr.aria-labelledby]="'persoon'+persoon.Id" >{{persoon.Naam}}</label>
          </div>
          
        </div>
      </div>

    </div>
    <div class="buttons-row">
      <button type="button" (click)="cancel()" class="btn btn-default">Annuleer</button>
      <button class="btn btn-primary">{{vm.isEdit  ? 'Bewaar' : 'Reageer'}}</button>
    </div>
  </form>
</ng-container>